import React from "react";
import Section from "./../Section/section";
import RenderChildren from "../../../hoc/renderChildren";
import PropTypes from "prop-types";

import iconBenefits from "../../../assets/images/icon-benefits.svg";
import "./benefits.scss";


export const MediaCard = (props) => {
  const { title, text } = props;

  return (
    <div className="media mb-4">
      <img className="mr-3" src={iconBenefits} alt="benefits icon"/>
      <div className="media-body text-muted">
        <h3 className="h5 mt-0 text-dark">{title}</h3>
        <p className="media-text">{text}</p>
      </div>
    </div>
  );
};

MediaCard.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

const Benefits = () => {
  return (
    <Section
      name="benefits"
      header="Features that make sense."
      subHeader="And make your life easier."
    >
      <RenderChildren>
        <div className="row">
          <div className="col-12 col-md-6">
            <MediaCard title="Financial freedom" text="Break free from the burden of high-interest debt." />
          </div>
          <div className="col-12 col-md-6">
            <MediaCard title="$0 in fees" text="With a Barclays Personal Loan, you'll pay no fees of any kind." />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <MediaCard title="Quick rate check" text="Checking your rate won't affect your credit score." />
          </div>
          <div className="col-12 col-md-6">
            <MediaCard title="Flexibility" text="Choose your payment due date or pay off your loan early." />
          </div>
        </div>
      </RenderChildren>
    </Section>
  );
};

export default Benefits;
